import HeaderSearch from './headerSearch'

$('body.soviets .js__headerSearch').each(function() {
  $(this).reactify(HeaderSearch)
})
